export const kebabCase = (str) => str.replaceAll(/\s/g, "-");